import { render, staticRenderFns } from "./DlgPostsNew.vue?vue&type=template&id=361638d0&scoped=true&"
import script from "./DlgPostsNew.vue?vue&type=script&lang=ts&"
export * from "./DlgPostsNew.vue?vue&type=script&lang=ts&"
import style0 from "./DlgPostsNew.vue?vue&type=style&index=0&id=361638d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "361638d0",
  null
  
)

export default component.exports